import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, message, Popover, Collapse, Menu } from 'antd';
import Page from '../../services/api/page';
import data from './data.json';
import ContasiscorpLogo from './img/contasiscorp-logo.webp';
import ContasiscorpLogoMobile from './img/contasiscorp-logo_mobile.webp';
import menu from './img/menu.webp';
import user from './img/user.jpg';
import youtube_icono from './img/youtube_icono.svg';
import Cookie from 'js-cookie';
import SubMenuBarra from '../../components/SubMenu';
import icon_plus from './img/icon_plus.png';
import left from './img/left.png';
import Barra from '../../components/barra_friday_2/Barra';

import './styles.scss';
const { Panel } = Collapse;
const { SubMenu } = Menu;

class MenuPage extends Component {
  state = {
    menu_active: '/',
    visible: false,
    sub_menu: {},
    submenu_nombre_titulo: null,
    submenu_url_page_especificaciones: null,
    submenu_url_page_planes: null,
    active_sub_menu: '',
    Cookie_active: true,
    current: 'mail',
    solucion_tipo: 0,
    soluciones_modulo:[
      [
        {
          titulo: 'Contable SQL',
          descripcion: 'Simplifica y automatiza la contabilidad de tus clientes.',
          link:'/contador-digital'
        },
        {
          titulo: 'Darwin SIRE',
          descripcion: 'El primer asistente digital que automatiza SIRE.',
          link:'/contador-digital/#darwin_modulo'
        },
        {
          titulo: 'Compliance Tributario',
          descripcion: 'Espacio digital de tributación online.',
          link:'/contador-digital'
        },
        {
          titulo: 'Inventario SQL',
          descripcion: 'Gestiona el kárdex en menos tiempo.',
          link:'/contador-digital?seccion=inventarioSQL'
        },
        {
          titulo: 'Recursos Humanos',
          descripcion: 'Gestiona la planilla de tus clientes.',
          link:'/contador-digital?seccion=contadorRRHH'
        },
        {
          titulo: 'Activo Fijo',
          descripcion: 'Integra la gestión contable de tus principales activos.',
          link:'/contador-digital?seccion=activoFijo'
        },
      ],
      [
        {
          titulo: 'Contable Financiero SQL',
          descripcion: 'Contabilidad financiera y tributaria.',
          link:'/empresa-digital'
        },
        {
          titulo: 'Comercial SQL',
          descripcion: 'Compras, ventas y almacén integrados a tu contabilidad.',
          link:'/empresa-digital?seccion=comercialSQL'
        },
        {
          titulo: 'Facturación Electrónica Web',
          descripcion: 'Gestiona tus comprobantes electrónicos en la nube.',
          link:'/facturacion-electronica'
        },
        {
          titulo: 'Recursos Humanos',
          descripcion: 'Gestiona la planilla de tu equipo e intégrala a contabilidad.',
          link:'/empresa-digital?seccion=empresaRrhh'
        },
        {
          titulo: 'SAF NIIF',
          descripcion: 'Integra la gestión contable de tus principales activos.',
          link:'/saf-niif'
        }
      ],
      [
        {
          titulo: 'Plan Contador Digital',
          descripcion: 'Formando contador digitales relevantes para la sociedad.',
          link:'/universidades'
        },
      ],
      [
        {
          titulo: 'Negocios Online',
          descripcion: 'El nuevo erp que incorpora contabilidad electrónica.',
          link:'/negocios-online'
        },
        {
          titulo: 'Negocios Online - Planes',
          descripcion: 'Elige el plan perfecto para tu negocio.',
          link:'/negocios-online/planes'
        }
      ]
    ],
  };

  handleClickMenu = (item) => {
    this.setState({
      sub_menu: item,
      menu_active: item.nombre_menu,
      active_sub_menu: item.active_sub_menu,
    }, ()=>{
    });
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.plan !== this.state.plan ||
      prevState.nube_aws !== this.state.nube_aws
    ) {
      this.actualizarProductoEmpresaVisible(prevState.plan, prevState.nube_aws);
    }
  }

  componentDidMount() {
    if (this.props && this.props.props && this.props.props.location) {
      this.setState({
        active_sub_menu: this.props.props.location.pathname,
      });
    }

    this.loadSubmenu();
  }

  setForm = (ref) => {
    this.formRef = ref;
  };

  loadSubmenu = () => {
    const pathname = window.location.pathname;
    let palabras = pathname.split('/');
    palabras = palabras.slice(1);
    for (let i = 0; i < data.length; i++) {
      if (data[i].active_sub_menu === '/' + palabras[0]) {
        this.handleClickMenu(data[i]);
      }
    }
  };

  showDrawer = () => {
    this.setState({
      visible: this.state.visible !== true,
    });
  };

  removeCookie = () => {
    Cookie.remove('miusuario', { path: '/', domain: Page.constants.domain });
    this.setState({ Cookie_active: false });
    message.success('Ha cerrado exitosamente la sesión');
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  handleClick = (e) => {
    this.setState({
      current: e.key,
    });
  };

  handleItemMenuClick  = (item_number) => {
    this.setState((prevState)=>({
      solucion_tipo: item_number
    }));
  };

  render() {
    
    let usuario = Cookie.get('miusuario');
    if (usuario) {
      usuario = JSON.parse(usuario);
    }

    //this.setState({ Cookie_active: true });
    data &&
      data.length > 0 &&
      data.map((item) => {
        if (item.active_sub_menu === this.state.active_sub_menu) {
          //let sub_menu = item;
        }
        return item;
      });

    const content_producto_1 = (item) => (
      <div>
        {item.nombre_menu === 'soluciones' ? (
          <div className={this.state.solucion_tipo==0?"emp__sub--element element_seleccionado":"emp__sub--element"}>
            <a className="button" >
              <h2 className='sin_descripcion'>
                <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Contadores o Estudios Contables
              </h2>
            </a>
          </div>
        ) : item.nombre_menu === 'certificaciones' ? (
          <div className="emp__sub--element">
            <a className="button" href="https://www.contasiscorpcertificacion.com/">
              <h2>
                <i className="far fa-star" style={{ color: '#EA9A00' }}></i> Contasiscorp Certified
              </h2>
              <p>Certifícate como Contador Digital.</p>
            </a>
          </div>
        ) : item.nombre_menu === 'eventos' ? (
          <div className="emp__sub--element emp__sub--element--mi">
            <a className="button" style={{ paddingRight: 70 }} href="/masterclass">
              <h2>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.34898 14H4.66898V9.34142H0V4.65543H4.66047V0H9.33449V4.64345H14V9.33575H9.34898V14ZM5.61411 13.0545H8.40384V8.39023H13.0549V5.58897H8.38935V0.94552H5.60561V5.60095H0.945137V8.39622H5.61411V13.0548V13.0545Z"
                    fill="#EA9A00"
                  />
                </svg>{' '}
                Masterclass
              </h2>
              <p>Exclusivo para clientes Contasis.</p>
            </a>
          </div>
        ) : (
          ''
        )}
      </div>
    );

    const content_producto_2 = (item) => (
      <div>
        {item.nombre_menu === 'soluciones' ? (
          <div className={this.state.solucion_tipo==1?"emp__sub--element element_seleccionado":"emp__sub--element"}>
            <a className="button" >
              <h2 className='sin_descripcion'>
                <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Medianas o Grandes Empresas
              </h2>
            </a>
          </div>
        ) : item.nombre_menu === 'certificaciones' ? (
          <div className="emp__sub--element">
            <a className="button" href="https://www.certificacionemprendedor.com/">
              <h2>
                <i className="far fa-star" style={{ color: '#EA9A00' }}></i> Academia de Emprendedores
              </h2>
              <p>Certifícate como Emprendedor Digital.</p>
            </a>
          </div>
        ) : item.nombre_menu === 'eventos' ? (
          <div className="emp__sub--element">
            <a className="button" href="/eventos">
              <h2>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.34898 14H4.66898V9.34142H0V4.65543H4.66047V0H9.33449V4.64345H14V9.33575H9.34898V14ZM5.61411 13.0545H8.40384V8.39023H13.0549V5.58897H8.38935V0.94552H5.60561V5.60095H0.945137V8.39622H5.61411V13.0548V13.0545Z"
                    fill="#EA9A00"
                  />
                </svg>{' '}
                Talleres Contasis
              </h2>
              <p>Gratis para contadores y empresas.</p>
            </a>
          </div>
        ) : (
          ''
        )}
      </div>
    );

    const content_producto_3 = (item) => (
      <div>
        {item.nombre_menu === 'soluciones' ? (
          <div className={this.state.solucion_tipo==2?"emp__sub--element element_seleccionado":"emp__sub--element"}>
            <a className="button" >
              <h2 className='sin_descripcion'>
                <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Universidades o Institutos
              </h2>
            </a>
          </div>
        ) : item.nombre_menu === 'certificaciones' ? (
          <div className="emp__sub--element">
            <a className="button" href="https://www.contasiscorpcertificacion.com/curso/Contasiscorp-Enterprise-2023">
              <h2>
                <i className="far fa-star" style={{ color: '#EA9A00' }}></i> Blog Enterprise 5.0
              </h2>
              <p>Comunidad de empresarios con capacitaciones gratis.</p>
            </a>
          </div>
        ) : (
          ''
        )}
      </div>
    );

    const content_producto_4 = (item) => (
      <div>
        {item.nombre_menu === 'soluciones' ? (
          <div className={this.state.solucion_tipo==3?"emp__sub--element element_seleccionado":"emp__sub--element"}>
            <a className="button" >
              <h2 className='sin_descripcion'>
                <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Pequeñas empresas o emprendedores
              </h2>
            </a>
          </div>
        ) : (
          ''
        )}
      </div>
    );

    

    const content_producto = (item) => (
      <div>
        {item.nombre_menu === 'servicio-al-cliente' || item.nombre_menu === 'certificaciones' || item.nombre_menu === 'eventos' || item.nombre_menu === 'mi-contasis' || item.nombre_menu === 'nosotros' ? (
          ''
        ) : (
          <p className="emp__sub--tittle">
            <i className="far fa-star" style={{ color: '#EA9A00' }}></i> Productos estrella:
          </p>
        )}
        {item.nombre_menu === 'contador-digital' || item.nombre_menu === 'emprendedores' ? (
          <p className="emp__sub--tittle">
            <i className="far fa-star" style={{ color: '#EA9A00' }}></i> Producto estrella:
          </p>
        ) : (
          ''
        )}
      </div>
    );

    const content_mas = (item) => (
      <div>
        {item.nombre_menu === 'servicio-al-cliente' ||
        item.nombre_menu === 'emprendedores' ||
        item.nombre_menu === 'certificaciones' ||
        item.nombre_menu === 'nosotros' ||
        item.nombre_menu === 'mi-contasis' ||
        item.nombre_menu === 'eventos' ? (
          ''
        ) : (
          <p className="emp__sub--tittle">
            <img src={icon_plus} alt='icono plus'/> Más productos:
          </p>
        )}
      </div>
    );
    const content_visita = (item) => (
      <div>
        {item.nombre_menu === 'servicio-al-cliente' ||
        item.nombre_menu === 'emprendedores' ||
        item.nombre_menu === 'certificaciones' ||
        item.nombre_menu === 'nosotros' ||
        item.nombre_menu === 'mi-contasis' ||
        item.nombre_menu === 'eventos' ? (
          ''
        ) : (
          <p className="emp__sub--tittle">
            <img src={icon_plus} alt='icono plus'/> Visita nuestro nuevo blog:
          </p>
        )}
      </div>
    );
    const soluciones = (
      <div className="new__menu">
        <a href="#" className="button new__menu--item new__menu--modulo">
          <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Contadores o Estudios Contables
        </a>
        <a href="/contador-digital" className="button new__menu--item ">
          Contable SQL
        </a>
        <a href="/contador-digital/#darwin_modulo" className="button new__menu--item">
          Darwin SIRE
        </a>
        <a href="/contador-digital" className="button new__menu--item">
          Compliance Tributario
        </a>
        <a href="/contador-digital?seccion=inventarioSQL" className="button new__menu--item">
          Inventario SQL
        </a>
        <a href="/contador-digital?seccion=contadorRRHH" className="button new__menu--item">
          Recursos Humanos
        </a>
        <a href="/contador-digital?seccion=activoFijo" className="button new__menu--item">
          Activo Fijo
        </a>
        <a href="#" className="button new__menu--item new__menu--modulo">
          <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Medianas o Grandes Empresas
        </a>
        <a href="/empresa-digital" className="button new__menu--item">
          Contable Financiero SQL
        </a>
        <a href="/empresa-digital?seccion=comercialSQL" className="button new__menu--item">
          Comercial SQL
        </a>
        <a href="/facturacion-electronica" className="button new__menu--item">
          Facturación Electrónica Web
        </a>
        <a href="/empresa-digital?seccion=empresaRrhh" className="button new__menu--item">
          Recursos Humanos
        </a>
        <a href="/saf-niif" className="button new__menu--item">
          SAF NIIF
        </a>
        <a href="#" className="button new__menu--item new__menu--modulo">
          <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Universidades e Institutos
        </a>
        <a href="/universidades" className="button new__menu--item">
          Plan Contador Digital
        </a>
        <a href="#" className="button new__menu--item new__menu--modulo">
          <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Pequeñas empresas
        </a>
        <a href="/negocios-online" className="button new__menu--item">
          Negocios Online
        </a>
        <a href="/negocios-online/planes" className="button new__menu--item">
          Negocios Online - Planes
        </a>
      </div>
    );

    const certificaciones = (
      <div className="new__menu">
        <a href="https://www.contasiscorpcertificacion.com/" className="button new__menu--item new__menu--resaltado">
          <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Contasiscorp Certified
        </a>
        <a href="https://www.certificacionemprendedor.com/" className="button new__menu--item new__menu--resaltado">
          <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Academia de Emprendedores
        </a>
        <a href="https://www.certificacionemprendedor.com/" className="button new__menu--item new__menu--resaltado">
          <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Blog Enterprise 5.0
        </a>
        {/* <a href="/eventos" className="button new__menu--item">
          <i className="far fa-star" style={{ color: '#EA9A00', fontSize: 12 }}></i> Eventos Online
        </a> */}
      </div>
    );

    const eventos = (
      <div className="new__menu">
        <a href="/masterclass" className="button new__menu--item new__menu--resaltado">
          <svg style={{ marginRight: 8 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.34898 14H4.66898V9.34142H0V4.65543H4.66047V0H9.33449V4.64345H14V9.33575H9.34898V14ZM5.61411 13.0545H8.40384V8.39023H13.0549V5.58897H8.38935V0.94552H5.60561V5.60095H0.945137V8.39622H5.61411V13.0548V13.0545Z"
              fill="#EA9A00"
            />
          </svg>
          Masterclass
        </a>
        {/* <a href="/talleres-negocios" className="button new__menu--item new__menu--resaltado">
          <svg style={{ marginRight: 8 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.34898 14H4.66898V9.34142H0V4.65543H4.66047V0H9.33449V4.64345H14V9.33575H9.34898V14ZM5.61411 13.0545H8.40384V8.39023H13.0549V5.58897H8.38935V0.94552H5.60561V5.60095H0.945137V8.39622H5.61411V13.0548V13.0545Z"
              fill="#EA9A00"
            />
          </svg>
          Talleres para Emprendedores
        </a> */}
        <a href="/eventos" className="button new__menu--item new__menu--resaltado">
          <svg style={{ marginRight: 8 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.34898 14H4.66898V9.34142H0V4.65543H4.66047V0H9.33449V4.64345H14V9.33575H9.34898V14ZM5.61411 13.0545H8.40384V8.39023H13.0549V5.58897H8.38935V0.94552H5.60561V5.60095H0.945137V8.39622H5.61411V13.0548V13.0545Z"
              fill="#EA9A00"
            />
          </svg>
          Talleres Contasis
        </a>
      </div>
    );
    

    return (
      <div>
        <div className={window.location.pathname === '/cloud' ? "contenedor-menu-cloud": (window.location.pathname === '/' || window.location.pathname === '/contador-digital' || window.location.pathname === '/contador-digital/soluciones-contador'?"contenedor-menu":'contenedor-menu contenedor-menu-no-home')}>
          <Barra />
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className="contenedor menu responsive">
                <div>
                  <Link
                    to="/"
                    onClick={() => {
                      this.handleClickMenu('home');
                    }}
                  >

                    <img className="menu__logo ver_web" src={ContasiscorpLogo} alt="Contasiscorp Logo" />
                    <img className="menu__logo ver_mobile" src={ContasiscorpLogoMobile} alt="Contasiscorp Logo" />
                  </Link>
                </div>
                <div className="">
                  <nav>
                    <ul>
                      {data && data.length > 0
                        ? data.map((item, index) => {
                            return ( index==1? 
                              <Popover overlayClassName="popover-soluciones" placement="bottomLeft" content={
                                <div className='secciones'>
                                  <div className='seccion seccion01'>
                                    <ul className='items--menu'>
                                      <li key='0' onMouseEnter={() => this.handleItemMenuClick(0)} >{content_producto_1(item)}</li>
                                      <li key='1' onMouseEnter={() => this.handleItemMenuClick(1)} >{content_producto_2(item)}</li>
                                      <li key='2' onMouseEnter={() => this.handleItemMenuClick(2)} >{content_producto_3(item)}</li>
                                      <li key='3' onMouseEnter={() => this.handleItemMenuClick(3)} >{content_producto_4(item)}</li>
                                    </ul>
                                    <div className='fin_seccion'>
                                      Todos nuestros módulos son integrables. Contasis®
                                    </div>
                                  </div>
                                  <div className='seccion seccion02' ey={index}>
                                    {this.state.soluciones_modulo && this.state.soluciones_modulo[this.state.solucion_tipo] && this.state.soluciones_modulo[this.state.solucion_tipo].map((item, index2)=>(                                      
                                      <a className='solucion' href={item.link} key={item.index}>
                                        <div className='titulo'>{item.titulo} </div>
                                        <div className='descripcion'>{item.descripcion} </div>
                                      </a>                                      
                                    ))}
                                  </div>
                                </div>
                              } trigger="hover">
                                <div className='contenedor-menu-soluciones'>
                                  <a className='menu-soluciones' href={item.url === '/servicio-cliente' ? '/servicio-cliente' : 
                                      item.url === '/nosotros' ? '/nosotros' :
                                      item.url == 'https://cuenta.contasiscorp.com/login' ? 'https://cuenta.contasiscorp.com/login' :
                                      item.url === '/academia-contasis' ? '/academia-contasis' : '#'
                                      }>{item.nombre}</a>
                                  <div className="triangulo_menu"></div>
                                  <div className="cuadrado_menu"></div>
                                </div>
                              </Popover>
                              :
                              <Menu key={index} selectedKeys={[this.state.current]} mode="horizontal" className="titulo__menu--principal">
                                <SubMenu
                                  title={
                                    <div className={window.location.pathname === '/nosotros' && item.url === '/nosotros'?'seleccionado-nosotros' :''}>
                                      <a href={item.url === '/servicio-cliente' ? '/servicio-cliente' : 
                                          item.url === '/nosotros' ? '/nosotros' :
                                          item.url === '/academia-contasis' ? '/academia-contasis' :
                                          item.url == 'https://cuenta.contasiscorp.com/login' ? 'https://cuenta.contasiscorp.com/login' : '#'}>{item.nombre}</a>
                                      <div className="triangulo_menu"></div>
                                      <div className="cuadrado_menu"></div>
                                    </div>
                                  }
                                  key={index}
                                  popupClassName={window.location.pathname === '/cloud'?`emp-full emp-full-cloud popover__sub_menu__${item.nombre_menu}`:(window.location.pathname === '/'?`emp-full popover__sub_menu__${item.nombre_menu}`:`emp-full emp-full-no-home popover__sub_menu__${item.nombre_menu}`)}
                                >
                                  <Menu.Item key="1">{content_producto_1(item)}</Menu.Item>
                                  <Menu.Item key="2">{content_producto_2(item)}</Menu.Item>
                                  <Menu.Item key="3">{content_producto_3(item)}</Menu.Item>
                                  <Menu.Item key="4">{content_producto_4(item)}</Menu.Item>
                                </SubMenu>
                              </Menu>                      
                            );
                          })
                        : ''}
                    </ul>
                  </nav>
                </div>
                <div className="menu__acceso">
                  {usuario && this.state.Cookie_active ? (
                    <div className="accounts__header">
                      <Popover
                        className="user__popover"
                        placement="bottomRight"
                        title={
                          <div className="user">
                            <div className="user__img--body--container">
                              <img
                                className="user__img--body"
                                src={
                                  usuario && usuario.profile_image
                                    ? `${Page.constants.url_cuenta}${usuario && usuario.profile_image ? usuario.profile_image : ''}`
                                    : user
                                }
                              />
                            </div>
                            <div style={{ marginLeft: 32, textAlign: 'left' }}>
                              <p className="bienvenida">¡Hola!</p>
                              <p className="user__name">{usuario && usuario.name ? usuario.name : ''}</p>
                              <p className="user__email">{usuario && usuario.email ? usuario.email : ''}</p>
                              <a className="user--cuenta" href={`${Page.constants.url_cuenta}`} target="_blank" rel="noreferrer">
                                Ir a mi cuenta
                              </a>
                            </div>
                          </div>
                        }
                        content={
                          <div className="cerrar__session">
                            <a onClick={this.removeCookie} href={`${Page.constants.url_cuenta}/close`} target="_blank" rel="noreferrer">
                              Cerrar Sesión
                            </a>
                          </div>
                        }
                        trigger="click"
                      >
                        <img
                          className="user__img"
                          src={
                            usuario && usuario.profile_image
                              ? `${Page.constants.url_cuenta}${usuario && usuario.profile_image ? usuario.profile_image : ''}`
                              : user
                          }
                        />
                      </Popover>
                    </div>
                  ) : (
                    <div>
                      <a className="button button--primary" href={`${Page.constants.url_cuenta}/login`} >
                        Ingresar
                      </a>
                      <a className="button button--default" href={`https://www.youtube.com/channel/UCXHEcpJot0yRXpkPe_Hl2QQ?view_as=subscriber`} style={{ marginLeft: 16 }}>
                        <img src={youtube_icono} alt='icono youtube'/> Contasis
                      </a>                      
                    </div>
                  )}
                </div>
                <div className="icon__menu">
                  <Popover
                    overlayClassName={window.location.pathname === '/cloud'?"menu__responsive--full--cloud": (window.location.pathname === '/' || window.location.pathname === '/contador-digital' || window.location.pathname === '/contador-digital/soluciones-contador' ?"menu__responsive--full":"menu__responsive--full menu__responsive--full-no-home")}
                    title={null}
                    content={
                      <div>
                        <Collapse accordion bordered={false} expandIconPosition="right" className="new__collapse__responsive">
                          <Panel
                            showArrow={false}
                            header={
                              <a className="new__title button borde_top" href="/nosotros">
                                <span className="text--left">Nosotros</span>
                              </a>
                            }
                            key="1"
                          ></Panel>
                          <Panel
                            showArrow={false}
                            header={
                              <a className="new__title button">
                                <span className="text--left">Soluciones</span>
                                <img src={left} alt='icono left'/>
                              </a>
                            }
                            key="2"
                          >
                            {soluciones}
                          </Panel>
                          <Panel
                            showArrow={false}
                            header={
                              <a className="new__title button" href="/academia-contasis">
                                <span className="text--left">Academia Contasis</span>
                              </a>
                            }
                            key="3"
                          >
                          </Panel>
                          <Panel
                            showArrow={false}
                            header={
                              <div className="new__title button">
                                <span className="text--left">Webinars</span>
                                <img src={left} alt='icono left'/>
                              </div>
                            }
                            key="4"
                          >
                            {eventos}
                          </Panel>
                          <Panel
                            showArrow={false}
                            header={
                              <a className="new__title button" href="/servicio-cliente">
                                <span className="text--left">Servicio al cliente</span>
                              </a>
                            }
                            key="5"
                          ></Panel>
                          <Panel
                            showArrow={false}
                            header={
                              <a className="new__title button" href={`${Page.constants.url_cuenta}/login`} >
                                <span className="text--left">Mi Contasis</span>
                              </a>
                            }
                            key="6"
                          ></Panel>                          
                        </Collapse>
                        <div className="contenedor_botones">
                          <a className="button button--primary" href={`${Page.constants.url_cuenta}/login`} style={{ marginTop: 20 }}>
                            Ingresar
                          </a>
                          <a className="button button--default" href={`https://www.youtube.com/channel/UCXHEcpJot0yRXpkPe_Hl2QQ?view_as=subscriber`}>
                            <img src={youtube_icono} alt='icono youtube'/> Contasis
                          </a>                          
                        </div>                        
                      </div>
                    }
                    trigger="click"
                  >
                    <img src={menu} className='menu_img' alt="Menu" />
                  </Popover>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className={this.state.active_sub_menu && this.state.sub_menu.sub_menu_item ? '' : 'hidden_element'}>
          <SubMenuBarra ref={this.setForm} object_sub_menu={this.state.sub_menu} />
        </div>
      </div>
    );
  }
}

export default MenuPage;
